import type { I18nFn } from 'i18n/types/I18nFn';

export enum VolopWelcomeType {
  FAMILIES = 'FAMILIES',
  TEENS = 'TEENS',
  GROUPS = 'GROUPS',
  INTL = 'INTL',
  AGE_55_PLUS = 'AGE_55_PLUS',
  PRIVATE_CORP_GROUPS = 'PRIVATE_CORP_GROUPS',
}

export function VOLOP_WELCOME_TYPE(i18n: I18nFn) {
  return {
    [VolopWelcomeType.FAMILIES]: i18n('Families'),
    [VolopWelcomeType.TEENS]: i18n('Teens'),
    [VolopWelcomeType.GROUPS]: i18n('Public Groups'),
    [VolopWelcomeType.INTL]: i18n('International Volunteers'),
    [VolopWelcomeType.AGE_55_PLUS]: i18n('Age 55+'),
    [VolopWelcomeType.PRIVATE_CORP_GROUPS]: i18n('Private Corporate Groups'),
  };
}

export function VOLOP_WELCOME_OPTIONS(i18n: I18nFn) {
  return Object.entries(VOLOP_WELCOME_TYPE(i18n))
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      name: key as keyof typeof VOLOP_WELCOME_TYPE,
      label: value,
    }));
}

export function VOLOP_WELCOME_RADIO_OR_SELECT_OPTIONS(i18n: I18nFn) {
  return Object.entries(VOLOP_WELCOME_TYPE(i18n))
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      value: key as keyof typeof VOLOP_WELCOME_TYPE,
      label: value,
    }));
}
